import { TeamDropInfoType, TeamDropInfo } from './team-game';

export class RemovedTeam {
    public teamName: string;
    public gamesLeft: number = 0;
    public groupId: string;
    public color: string;

    public onDropCallback: (dropData: TeamDropInfo) => void;

    constructor(teamName: string, gamesLeft: number, groupId: string, color: string, onDropCallback: (dropData: TeamDropInfo) => void) {
        this.teamName = teamName;
        this.gamesLeft = gamesLeft;
        this.groupId = groupId;
        this.color = color;
        this.onDropCallback = onDropCallback;
    }

    public dragTeam(ev: DragEvent): boolean {
        ev.dataTransfer.setData('team', this.teamName);
        ev.dataTransfer.setData('type', TeamDropInfoType.removedTeam.toString());
        ev.dataTransfer.setData('interval', '-1');
        ev.dataTransfer.setData('venueKey', '');
        ev.dataTransfer.setData('groupId', this.groupId ?? '');
        return true;
    }

    public allow(ev: DragEvent): void {
        ev.preventDefault();
    }

    public dropTeam(ev: DragEvent): void {
        ev.preventDefault();
        const sourceTeam = ev.dataTransfer.getData('team');
        const sourceTeamType = parseInt(ev.dataTransfer.getData('type'), 10) as TeamDropInfoType;
        const sourceInterval = parseInt(ev.dataTransfer.getData('interval'), 10);
        const sourceVenueKey = ev.dataTransfer.getData('venueKey');
        const dropData = new TeamDropInfo(sourceTeam, sourceTeamType, sourceInterval, sourceVenueKey, this.teamName, TeamDropInfoType.removedTeam, -1, '');
        this.onDropCallback(dropData);

    }
}
